/*====================================
  コレクションページ
====================================*/
/*
* アイコンの表示制御
*/
function controlProductIconDisplay(serverResponse){
  var newIconClass = '.price__badge-new';//新商品タグのclass名
  var gridItemClass = '.card-wrapper';//グリッドの各商品を括っているclass名
  var productItem;

  //新商品タグの数分処理
  for( var i=0; i<$( newIconClass ).length; i++ ){
    //各商品のDOMを取得
    $productItem = $( newIconClass ).eq(i).parents( gridItemClass );
    if( $productItem.length ){
      //新商品アイコンの表示制御
      mainControlNewProductIconDisplay( serverResponse, $productItem );
    }
  }

  //Product Page
  $productItem = $( '.product__info-container' );
  if( $productItem.length ){
      //新商品アイコンの表示制御
      mainControlNewProductIconDisplay( serverResponse, $productItem );
  }
  if( $( '.product-recommendation' ).length ){
      $productItem = $( '.card-wrapper' );
      if( $productItem.length ){
          //新商品アイコンの表示制御
          mainControlNewProductIconDisplay( serverResponse, $productItem );
      }
  }
}

/*
* 新商品アイコンの表示制御（メイン処理）
*/
function mainControlNewProductIconDisplay( serverResponse, $productItem ){

  var displayPeriod = 7;//新商品タグの表示期間
  var newIconClass = '.price__badge-new';//新商品タグのclass名
  //今日の日付を取得
  var today = new Date(serverResponse);

  //発売日を取得
  var releaseDateStr = $productItem.find( '.js-release_date' ).text().trim();

  if(releaseDateStr) {
    var releaseDate = new Date(releaseDateStr);
    var releaseDateEnd = new Date(releaseDateStr);

    //表示期間の最終日を計算
    releaseDateEnd.setDate(releaseDateEnd.getDate() + displayPeriod);

    //表示期間を過ぎている
    if( today.getTime() < releaseDateEnd ){
        // 新商品タグを非表示
        $productItem.find( newIconClass ).show();
    }
  } else {
    $productItem.find( newIconClass ).hide();
  }
}

/*
* 現在時刻をサーバーから取得して各種処理
*/
function processingMultipleGetServerDate(){
  $.ajax({
  type : 'HEAD',
  url :  window.location.href,
  cache : false
  }).done(function(data, textStatus, xhr) {
  try {
      var serverResponse = new Date(xhr.getResponseHeader("Date"));
  } catch(e) {
      var serverResponse = new Date();
  }

  //Collection Page / Search Page
  if( $( '.template-search' ).length || $( '.template-collection' ).length ){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);
  }

  //topのnew arrival / recommend / ranking
  if( $( '.template-new-arrival' ).length || $( '.template-recommend' ).length || $( '.template-ranking' ).length ){
      controlProductIconDisplay(serverResponse);
  }

  //Product page / Cart page
  if( $( '.template-product' ).length > 0 || $( '.template-cart' ).length > 0 ){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);
  }

  }).fail(function() {
  var serverResponse = new Date();
  // 失敗時の制御
  });
  
}

processingMultipleGetServerDate();

if( $( '.template-search' ).length || $( '.template-collection' ).length ) {
  var previousURL = window.location.href;

  function watchURLChange2() {
    // 現在のURLを取得
    var currentURL = window.location.href;

    // URLが変更されたかどうかを確認
    if (currentURL !== previousURL) {
      // URLが変更された場合の処理
      previousURL = currentURL;

      // URLが変更された後の処理を実行
      setTimeout(function(){
        processingMultipleGetServerDate();
      },1500);
    }
  }
  // 定期的にURLの変更を監視する
  setInterval(watchURLChange2, 300);
}


//トップへ戻るのボタン非表示と表示
if(window.matchMedia("(max-width: 749px)").matches){
	;
}else{ 
	$(function () {
    $(window).scroll(function () {
      var scroll = $(this).scrollTop();
      if (scroll > 600) {
        $(".back-to-top").fadeIn('600');
      } else {
        $(".back-to-top").fadeOut('600');
      }
    });
  });
}

/*====================================
  商品詳細
====================================*/
// 数量選択プルダウン選択時に数量保持
$(document).on('change', '#quantity-pulldown', function(){
  var selectedQuantity = $('#quantity-pulldown').val();
  $("input.quantity__input").val(selectedQuantity);
});

// swatchKingのSizeラベル位置を修正
// 変更を監視するノードを選択
const targetNode = document.getElementsByClassName('product__info-container')[0];
// 子要素を監視するよう設定
const config = { childList: true };
// 変更が発見されたときに実行されるコールバック関数
const callback = function(mutationsList, observer) {
    for(const mutation of mutationsList) {
        if($('#swatch-option2').length){
          $('#swatch-option2 .swatch-label-inside').insertBefore('#swatch-option2');
          // 監視を停止
          observer.disconnect();
        }
    }
};
// コールバック関数に結びつけられたオブザーバーのインスタンスを生成
const observer = new MutationObserver(callback);
// ページが商品詳細画面のとき、対象ノードの設定された変更の監視を開始
if($('.product__info-wrapper').length){
  observer.observe(targetNode, config);
}

// ページが商品詳細画面のとき、Recommend Itemsのバッジを非表示
$(window).on('load', function() {
  if($('.product__info-wrapper').length){
    setTimeout(function(){
      $('.related-products .card__badge').css({'display': 'none'});
      // 商品画像がカルーセル表示の場合、サムネイル部分を表示
      classLength = $(".slider-thumbnail").length;
      if(classLength){
        $('.slider-thumbnail').css({'visibility': 'visible'});
      }
    },1000);
  }
});

// 商品説明タブ切り替え
$('.discription-tab-content>div').hide();
$('.discription-tab-content>div').first().slideDown();
$('.discription-tab-buttons span').click(function(){
  var thisclass=$(this).attr('class');
  $('#discription-lamp').removeClass().addClass('#discription-lamp').addClass(thisclass);
  if(thisclass === 'discription-tab-content1'){
    // クリックされたクラスがdiscription-tab-content1の場合
    $('.discription-tab-content1').css({'cssText': 'color: #111111 !important;'});
    $('.discription-tab-content2').css({'cssText': 'color: #777777 !important;'});
  }
  else if(thisclass === 'discription-tab-content2'){
    // clickされたクラスがdiscription-tab-content2の場合
    $('.discription-tab-content1').css({'cssText': 'color: #777777 !important;'});
    $('.discription-tab-content2').css({'cssText': 'color: #111111 !important;'});
  }
  $('.discription-tab-content>div').each(function(){
    if($(this).hasClass(thisclass)){
      $(this).fadeIn(800);
    }
    else{
      $(this).hide();
    }
  });
});

// // 商品画像スワイパー
// function mainProductSwiper(){
//   // サムネイル
//   const productImageSliderThumbnail = new Swiper(".slider-thumbnail", {
//     // 前後の矢印
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     scrollbar: {
//       el: '.swiper-scrollbar',
//       draggable: true,
//     },
//     slidesPerView: 4.4,
//     spaceBetween: 7.5,
//     breakpoints: {
//       750: {
//         slidesPerView: 6, // サムネイルの枚数
//         spaceBetween: 10, // スライド間の余白
//       },
//     },
//   });
//   // スライダー
//   const productImageSlider = new Swiper(".product-image-slider", {
//     thumbs: {
//       swiper: productImageSliderThumbnail,
//     },
//     spaceBetween: 15,
//     breakpoints: {
//       // スライドの表示枚数：600px以上の場合
//       750: {$(".simplebar-content-wrapper").mousedragscrolla
//         spaceBetween: 0,
//       },
//     },
//   });
// }
// mainProductSwiper();

if ($('.thumbnail-list').length > 0) {
  // サムネイルにSimplebar付与
  const ulElement = document.querySelector('.simplebar-thumbnail'); // 対象の<ul>要素を選択
  new SimpleBar(ulElement, { autoHide: false });
  
  if ($('.show-when-load-thumb').length > 0) {
    // 初期表示でサムネイル画像をスクロール
    // サムネイルのスクロール位置を計算する
    const sliderSimplebar = document.querySelector('.simplebar-content-wrapper'); // .simplebar-content要素を取得
    const thumbnail = document.querySelector('.show-when-load-thumb');
    const scrollPosition = thumbnail.offsetLeft;
    // シンプルバースクロールアニメーションのパラメータ
    const scrollOptions = {
      left: scrollPosition,
      behavior: 'smooth',
      block: 'start',
    };
    // thumbnail.offsetLeftにスムーススクロール
    sliderSimplebar.scrollTo(scrollOptions);
  }

  // 初期表示でメイン画像をスクロール
  const targetLi = document.querySelector('.show-when-load');
  if (targetLi) {
    const targetUl = document.querySelector(".product__media-list");
    const targetPosition = targetLi.offsetLeft;
    $(targetUl).animate({
      scrollLeft: targetPosition
    }, 300, 'swing');
  }

  var check = setInterval(function() {
    if ($('.thumbnail-list__item img').length > 0) {
      var height = $('.thumbnail-list__item').innerHeight();
      var height = height + 15;
      $('.thumbnail-list').css('padding-top', height);
      $(".simplebar-content-wrapper").mousedragscrollable();
      clearInterval(check); // 監視を停止
    }
  }, 500); // 0.5秒ごとにチェック
  // PCのメイン画像スライドするようにする
  const childern = document.querySelectorAll(".product__media-item ");
  const parent = document.querySelector(".product__media-list");

  let isDragging = false;
  let startX;
  let scrollLeft;

  parent.addEventListener("mousedown", (e) => mouseIsDown(e));
  parent.addEventListener("mouseup", (e) => mouseUp(e));
  parent.addEventListener("mouseleave", (e) => mouseLeave(e));
  parent.addEventListener("mousemove", (e) => mouseMove(e));

  function mouseIsDown(e) {
    isDragging = true;
    startX = e.pageX - parent.offsetLeft;
    scrollLeft = parent.scrollLeft;
  }
  function mouseUp(e) {
    isDragging = false;
  }
  function mouseLeave(e) {
    isDragging = false;
  }
  function mouseMove(e) {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - parent.offsetLeft;
    const walkX = (x - startX) * 2; // ドラッグの速度を調整する場合は乗数を調整
    parent.scrollLeft = scrollLeft - walkX;
  }
}

 // ウィンドウのリサイズ時に計算を再実行
$(window).resize(function() {
  var height = $('.simplebar-content').innerHeight();
    var height = height + 15;
    $('.thumbnail-list').css('padding-top', height + "px");
});

// 拡大画像
const modalSwiper = new Swiper(".modal-swiper", {
  // 前後の矢印
  navigation: {
  nextEl: ".modal-swiper-button-next",
  prevEl: ".modal-swiper-button-prev",
  },
  preloadImages: false,
  lazy: true
});

function setProductMediaModal(slideNum) {
  $('.product-media-modal__dialog').css({'display': 'none'});
  modalSwiper.slideTo(slideNum);
  setTimeout(function(){
    $('.product-media-modal__dialog').css({'display': 'flex'});
  },100);
}

// 初期のURLを保存する変数
var previousURL = window.location.href;
// XMLHttpRequestを使ってAjaxで更新
function ajaxUpdate(url, element, callback) {
  // XMLHttpRequestオブジェクトを作成
  var xhr = new XMLHttpRequest();
  // GETリクエストを使用して読み込み先URLからデータを取得
  xhr.open("GET", url, true);
  // リクエストが完了したときのイベントハンドラ
  xhr.onload = function () {
    if (xhr.status === 200) {
      // レスポンスから読み込む要素を取得
      var parser = new DOMParser();
      var responseDoc = parser.parseFromString(xhr.responseText, "text/html");
      var destinationElement = responseDoc.getElementById(element);
      if (destinationElement) {
        // 読み込む要素を取得したら、読み込み元の要素に置き換える
        var sourceElement = document.getElementById(element);
        sourceElement.innerHTML = destinationElement.innerHTML;
      }
    }
  };
  // リクエストを送信
  xhr.send();
}

// URLの変更を監視する関数
function watchURLChange(){
  // 現在のURLを取得
  var currentURL = window.location.href;
  // URLが変更されたかどうかを確認
  if (currentURL !== previousURL) {
    // URLが変更された場合、画面を再読み込み
    previousURL = currentURL;
    $('.slider-thumbnail').css({'visibility': 'hidden'});

    ajaxUpdate(currentURL, "puroduct-media-swiper");
    ajaxUpdate(currentURL, "product-quantity-pulldown");
    ajaxUpdate(currentURL, "modal-swiper-wrapper");
    setTimeout(function(){
      mainProductSwiper();
      $('.slider-thumbnail').css({'visibility': 'visible'});
    },1500);
  }
}

// 商品画像がカルーセル表示の場合
classSliderThumbnailLength = $(".slider-thumbnail").length;
if(classSliderThumbnailLength){
  // 定期的にURLの変更を監視する
  setInterval(watchURLChange, 300);
}

$(document).on('click', '.modal-swiper-button-next', function() {
  // 他の要素から .active クラスを削除する（任意のセレクタを指定）
  $('.swiper-slide.active').removeClass('active');

  // .swiper-slide-active クラスが設定された要素を取得
  var activeElement = $('.swiper-slide-active');

  // .active クラスを移動させる
  activeElement.addClass('active');
});


/*====================================
  チェックした商品が0件の場合、見出しを非表示
====================================*/
$(window).on('load',function(){
  window.setTimeout(function(){
    var checkdItem = 0
    checkdItem = $(".owl-item").length;
    if(checkdItem < 1){
      $('.checked-item').css('display', 'none');
    }
  }, 500);
});

/*====================================
  スクロールフェードイン
====================================*/
// トップページの画面読み込み時にMaincontentを表示させる
$(window).on('load',function(){
  if($('.main-visual-overflow').length){
    $('#MainContent').css('display', 'block');
  }
});
// トップページのセクションにスクロールフェードインを適応
function scrollFadeIn() {
  if($('.main-visual-overflow').length){
    $('.animation-scroll-fadein').each(function(){
	  	//ターゲットの位置を取得
      var target = $(this).offset().top;
	  	//スクロール量を取得
      var scroll = $(window).scrollTop();
	  	//ウィンドウの高さを取得
      var height = $(window).height();
	  	//ターゲットまでスクロールするとフェードインする
      if (scroll > target - height){
	  		//クラスを付与
        $(this).addClass('active-scroll-fadein');
      }
    });
  }
};
$(window).on('load scroll',function (){
  scrollFadeIn();
});



/*====================================
  トップ Ranking
====================================*/
// タブ切り替え　タブアニメーション
$(function(){
  var w = $(window).width();
  var w_resize;
  var timer = false;
  var resizeFlg = false;
  var borderCalcFlg = true;
  
  // 画面読み込み時
  if( w <= 749 ) {
    //SP版
    $('.lampSign').css('display', 'none');
  } else {
    //PC版
    productPC ()
  }

  $(window).on('resize',function() {
      if (timer !== false) {
          clearTimeout(timer);
      }
      timer = setTimeout(function() {
          w_resize = $(window).width();
          if (w != w_resize && w_resize <= 749 && w >= 750){
            w = w_resize;
            $('.lampSign').toggle();
            resizeFlg = true;
            borderCalcFlg = false;
          } else if (w != w_resize && w_resize >= 750 && w <= 749) {
              w = w_resize;
              borderCalcFlg = true;
              productPC ();
          }
      }, 200);
  });

  function productPC () {
    if (resizeFlg){
      $('.lampSign').toggle();
    }
    // タブ切り替え　タブアニメーション
    $(window).on('load', function () {
      var lampSign = document.getElementsByClassName('lampSign');
      var jsTabBtnWrapSign = document.getElementsByClassName('js-tab-btn-wrap');
        if (borderCalcFlg){
          for (let i = 1; i < lampSign.length + 1; i++) {
            lampSign[i - 1].setAttribute("id", "lamp" + i);
            jsTabBtnWrapSign[i - 1].classList.add('js-tab-btn-wrap' + i);
            $('#lamp' + i).css('width', $('.js-tab-btn-wrap' + i + ' .active').outerWidth() + 'px');
            $('#lamp' + i).css('left', $('.js-tab-btn-wrap' + i + ' .active').position().left + 'px');
            $('.js-tab-btn-wrap' + i + ' .tabswitching_title').click(function () {
              setTimeout(function() {
                var thisclass = $(this).attr('class');
                $('').removeClass().addClass('#lamp' + i).addClass(thisclass);
                $('#lamp' + i).css('width', $('.js-tab-btn-wrap' + i + ' .active').outerWidth() + 'px');
                let off = $('.js-tab-btn-wrap' + i + ' .active').position();
                $('#lamp' + i).css('left', off.left + 'px');
              }, 100);
            });
          }
        }
    });
  }
});

/*====================================
  ページヘッダー
====================================*/
// ヘッダーの外側の高さを取得
var sectionHeaderHeight = 0;
// ヘッダーの中身を高さを取得
var headerWrapperHeight = 0;
// 外側と中身の差
var mainContentTranslate = 0;
// mainContentTranslateをtransform用に文字列化したもの
var strMainContentTranslate = ""

function mainContentTransform () {
  // ヘッダーの外側の高さを取得
  sectionHeaderHeight = $('.section-header').eq(0).outerHeight();
  // ヘッダーの中身を高さを取得
  headerWrapperHeight = $('.header-wrapper').eq(0).outerHeight();
  // 外側が中身より大きい場合、MainContentの位置を上げる
  if(sectionHeaderHeight > headerWrapperHeight){
    mainContentTranslate = headerWrapperHeight - sectionHeaderHeight;
    strMainContentTranslate = "translateY(" + mainContentTranslate + "px)";
    $("#MainContent").css({transform: strMainContentTranslate});
  }
}
// 画面読み込み時
$(window).on('load', function () {
  mainContentTransform();
});
// 画面リサイズ時
$(window).resize(function () {
  // スマホ版ではMainContentの位置をリセット
  if($(window).width() >= 750){
    mainContentTransform();
  }else{
    if(strMainContentTranslate != ""){
      $("#MainContent").css({transform: "translateY(0px)"});
      strMainContentTranslate = ""
    }
  }
});

/*====================================
  ドラッグスクロール
====================================*/
jQuery.prototype.mousedragscrollable = function () {
  let target;
  $(this).each(function (i, e) {
    $(e).mousedown(function (event) {
      event.preventDefault();
      target = $(e);
      $(e).data({
        down: true,
        move: false,
        x: event.clientX,
        y: event.clientY,
        scrollleft: $(e).scrollLeft(),
        scrolltop: $(e).scrollTop(),
      });
      return false;
    });
    $(e).click(function (event) {
      if ($(e).data("move")) {
        return false;
      }
    });
  });
  $(document)
    .mousemove(function (event) {
      if ($(target).data("down")) {
        event.preventDefault();
        let move_x = $(target).data("x") - event.clientX;
        let move_y = $(target).data("y") - event.clientY;
        if (move_x !== 0 || move_y !== 0) {
          $(target).data("move", true);
        } else {
          return;
        }
        $(target).scrollLeft($(target).data("scrollleft") + move_x);
        $(target).scrollTop($(target).data("scrolltop") + move_y);
        return false;
      }
    })
    .mouseup(function (event) {
      $(target).data("down", false);
      return false;
    });
};

$(function(){
  var w = $(window).width();
  var w_resize;
  var timer = false;
  var resizeFlg = false;
  var borderCalcFlg = true;
  
  // 画面読み込み時
  if( w <= 749 ) {
    //SP版
    productSP ()
  } else {
    //PC版
    ;
  }

  $(window).on('resize',function() {
      if (timer !== false) {
          clearTimeout(timer);
      }
      timer = setTimeout(function() {
          w_resize = $(window).width();
          if (w != w_resize && w_resize <= 749 && w >= 750){
            w = w_resize;
            productSP ();
            resizeFlg = true;
            borderCalcFlg = false;
          } else if (w != w_resize && w_resize >= 750 && w <= 749) {
              w = w_resize;
              productPC ();
          }
      }, 200);
  });

  function productPC () {
    ;
  }

  function productSP () {
    if ($('.feature-scroll-mobile').length > 0) {
      var interval2 = setInterval(function() {
        if ($('.feature-scroll-mobile-li img').length > 0) {
          var height = $('.feature-scroll-mobile-li').innerHeight();
          var height = height + 5;
          $('.feature-scroll-mobile').css('padding-top', height);
          $(".simplebar-content-wrapper").mousedragscrollable();
          clearInterval(interval2); // 監視を停止
        }
      }, 500); // 0.5秒ごとにチェック
    }
  }
});

/*====================================
  トップページ　category　アニメーション
====================================*/
document.addEventListener("DOMContentLoaded", () => {
  setUpAccordion();
});

/**
 * ブラウザの標準機能(Web Animations API)を使ってアコーディオンのアニメーションを制御します
 */
const setUpAccordion = () => {
  const details = document.querySelectorAll(".category-js-details");
  const RUNNING_VALUE = "running"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
  const IS_OPENED_CLASS = "category-is-opened"; // アイコン操作用のクラス名

  details.forEach((element) => {
    const summary = element.querySelector(".category-js-summary");
    const content = element.querySelector(".category-js-content");

    summary.addEventListener("click", (event) => {
      // デフォルトの挙動を無効化
      event.preventDefault();

      // 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする
      if (element.dataset.animStatus === RUNNING_VALUE) {
        return;
      }

      // detailsのopen属性を判定
      if (element.open) {
        // アコーディオンを閉じるときの処理
        // アイコン操作用クラスを切り替える(クラスを取り除く)
        element.classList.toggle(IS_OPENED_CLASS);

        // アニメーションを実行
        const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
        // アニメーション実行中用の値を付与
        element.dataset.animStatus = RUNNING_VALUE;

        // アニメーションの完了後に
        closingAnim.onfinish = () => {
          // open属性を取り除く
          element.removeAttribute("open");
          // アニメーション実行中用の値を取り除く
          element.dataset.animStatus = "";
        };
      } else {
        // アコーディオンを開くときの処理
        // open属性を付与
        element.setAttribute("open", "true");

        // アイコン操作用クラスを切り替える(クラスを付与)
        element.classList.toggle(IS_OPENED_CLASS);

        // アニメーションを実行
        const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
        // アニメーション実行中用の値を入れる
        element.dataset.animStatus = RUNNING_VALUE;

        // アニメーション完了後にアニメーション実行中用の値を取り除く
        openingAnim.onfinish = () => {
          element.dataset.animStatus = "";
        };
      }
    });
  });
}

/**
 * アニメーションの時間とイージング
 */
const animTiming = {
  duration: 400,
  easing: "ease-out"
};

/**
 * アコーディオンを閉じるときのキーフレーム
 */
const closingAnimKeyframes = (content) => [
  {
    height: content.offsetHeight + 'px', // height: "auto"だとうまく計算されないため要素の高さを指定する
    opacity: 1,
  }, {
    height: 0,
    opacity: 0,
  }
];

/**
 * アコーディオンを開くときのキーフレーム
 */
const openingAnimKeyframes = (content) => [
  {
    height: 0,
    opacity: 0,
  }, {
    height: content.offsetHeight + 'px',
    opacity: 1,
  }
];